<div>
  <input type="checkbox" class="checkbox" id="checkbox" [checked]="isLightTheme" (change)="onThemeSwitchChange()">
  <label for="checkbox" class="checkbox-label">
    <mat-icon class="fas fa-sun material-icons-outlined" [class.fa-dk-sun]="!this.isLightTheme" >wb_sunny</mat-icon>
    <mat-icon class="fas fa-moon material-icons-outlined">dark_mode</mat-icon>
    <span class="ball" [ngClass]="{'ballright':this.isLightTheme==true,'ballleft':this.isLightTheme==false }"></span>
  </label>
</div>
